import { ASTON_REDESIGN_STORAGE_URL } from 'constants/api';

const commonAssets = {
  favicon: `${ASTON_REDESIGN_STORAGE_URL}common/favicon/AstonFavicon.svg`,

  logo: {
    light: `${ASTON_REDESIGN_STORAGE_URL}common/logo/AstonLogo_light.svg`,
    dark: `${ASTON_REDESIGN_STORAGE_URL}common/logo/AstonLogo_dark.svg`,
  },

  phone: `${ASTON_REDESIGN_STORAGE_URL}common/icons/Phone_black.svg`,
  mail: `${ASTON_REDESIGN_STORAGE_URL}common/icons/Mail_black.svg`,
  aston: `${ASTON_REDESIGN_STORAGE_URL}common/icons/AstonIcon.svg`,
};

export default commonAssets;
